import { EventEmitter } from '@angular/core';
import { DateFormatPipe } from '@app/shared/pipes/moment/date-format.pipe';
import { ButtonDownloadCheckComponent, ButtonPreviewDocCheckComponent, DynamcColumnComponent } from '@app/shared';


export class CalendarConfig {
  // se emite cada vez que se realiza una accion con los botones de la tabla
  accion: EventEmitter<any> = new EventEmitter();
  // contiene la configuracion de la tabla
  settings = {};
  // contine la configuracion de la tabla dinamica
  dynamicSettings = {};

  constructor (structureDynamic?: any) {
    const self = this;
    var accents = require('remove-accents');
    this.settings = {
      mode: 'external',
      noDataMessage: 'Actualmente no hay historial',
      actions: false,
      attr: {
        class: 'table-bordered table-hover'
      },
      columns: {
        tramite_expediente: {
          title: 'Consecutivo del sistema',
          editable: false,
        },
        tramite_radicado_solicitud: {
          title: 'Radicado de solicitud',
          editable: false,
        },
        tramite_radicado_expediente: {
          title: 'Expediente',
          editable: false,
        },
        nombre_tramite: {
          title: 'Trámite',
          editable: false,
          filterFunction: (cell?: any, search?: string) => {
            if (cell){
              return accents.remove(cell.toLowerCase()).includes(accents.remove(search.toLowerCase())) ? true : false;
            }else{
              return false;
            }
          }
        },
        actividad: {
          title: 'Actividad',
          editable: false,
          filterFunction: (cell?: any, search?: string) => {
            if (cell){
              return accents.remove(cell.toLowerCase()).includes(accents.remove(search.toLowerCase())) ? true : false;
            }else{
              return false;
            }
          }
        },
        nombre: {
          title: 'Tarea',
          editable: false,
          filterFunction: (cell?: any, search?: string) => {
            if (cell){
              return accents.remove(cell.toLowerCase()).includes(accents.remove(search.toLowerCase())) ? true : false;
            }else{
              return false;
            }
          }
        },
        fecha_activacion: {
          title: 'Fecha de asignación',
          editable: false,
          sortDirection: 'desc',
          valuePrepareFunction: (cell: any, row: any) => {
            const formatted = new DateFormatPipe().transform(row.fecha_activacion);
            return formatted;
          }
        },
      },
    };
    if(structureDynamic){
      let columns = {};
      structureDynamic.estructura.forEach((cs: { tipo: string; alias: string | number; label: any;  ancho: number; })=>{
        if(cs.tipo == "documento"){
          if(cs.ancho){
            columns[cs.alias] = {
              title: cs.label,
              editable: false,
              sort: false,
              type: "custom",
              width: '' + cs.ancho +'%',
              filter: { },
              renderComponent: ButtonDownloadCheckComponent,
              onComponentInitFunction(instance: any) {
                instance.save.subscribe((data: any) => {
                  // controla el evento click del boton
                  const sendData = {
                    action: "descargar",
                    data: data,
                    type_document: cs.tipo
                  };
                  self.accion.emit(sendData);
                });
              },
            };
          }else{
            columns[cs.alias] = {
              title: cs.label,
              editable: false,
              sort: false,
              type: "custom",
              filter: { },
              renderComponent: ButtonDownloadCheckComponent,
              onComponentInitFunction(instance: any) {
                instance.save.subscribe((data: any) => {
                  // controla el evento click del boton
                  const sendData = {
                    action: "descargar",
                    data: data,
                    type_document: cs.tipo
                  };
                  self.accion.emit(sendData);
                });
              },
            };
          }
        }else if(cs.tipo == "preview_documento"){
          if(cs.ancho){
            columns[cs.alias] = {
              title: cs.label,
              editable: false,
              sort: false,
              type: "custom",
              width: '' + cs.ancho +'%',
              filter: { },
              renderComponent: ButtonPreviewDocCheckComponent,
              onComponentInitFunction(instance: any) {
                instance.save.subscribe((data: any) => {
                  // controla el evento click del boton
                  const sendData = {
                    action: "preview_documento",
                    data: data,
                    type_document: cs.tipo
                  };
                  self.accion.emit(sendData);
                });
              },
            };
          }else{
            columns[cs.alias] = {
              title: cs.label,
              editable: false,
              sort: false,
              type: "custom",
              filter: { },
              renderComponent: ButtonPreviewDocCheckComponent,
              onComponentInitFunction(instance: any) {
                instance.save.subscribe((data: any) => {
                  // controla el evento click del boton
                  const sendData = {
                    action: "preview_documento",
                    data: data,
                    type_document: cs.tipo
                  };
                  self.accion.emit(sendData);
                });
              },
            };
          }
        }else{
          if(cs.ancho){
            columns[cs.alias] = {
              addable: false,
              editable: false,
              filter: {
                inputClass: 'form-control'
              },
              sort: true,
              title: cs.label,
              width: '' + cs.ancho +'%',
              filterFunction: (cell?: any, search?: string) => {
                if (cell){
                  if(typeof(cell) == 'string'){
                    return accents.remove(cell.toLowerCase()).includes(accents.remove(search.toLowerCase())) ? true : false;
                  }else{
                    return cell.toString().includes(search) ? true : false;
                  } 
                }else{
                  return false;
                }
              }
            }
          }
          else{
            columns[cs.alias] = {
              addable: false,
              editable: false,
              filter: {
                inputClass: 'form-control'
              },
              sort: true,
              title: cs.label,
              filterFunction: (cell?: any, search?: string) => {
                if (cell){
                  if(typeof(cell) == 'string'){
                    return accents.remove(cell.toLowerCase()).includes(accents.remove(search.toLowerCase())) ? true : false;
                  }else{
                    return cell.toString().includes(search) ? true : false;
                  } 
                }else{
                  return false;
                }
              }
            }
          } 
        }
      })
      this.dynamicSettings = {
        actions: false,
        attr: {
          class: 'table-bordered table-hover'
        },
        columns: columns,
        mode: 'external',
        noDataMessage: 'No hay datos disponibles'
      };
    }
    
  }

  /**
   * Genera las columnas dinamicas del calendario de actividades
   *
   * @param {string} key
   * @param {string} title
   * @memberof CalendarConfig
   */
  generateColumn(key: string, title: string) {
    this.settings['columns'][key] = {
      title: title,
      editable: false,
      type: 'custom',
      renderComponent: DynamcColumnComponent,
      onComponentInitFunction() {}
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/calendar/shared/calendar.config.service.ts